/** @badge Custom — text-label pill (native Badge is number/dot only)
 *  @when   короткий неизменяемый ярлык рядом с текстом: «черновик», «beta», «моно»
 *  @not    кликабельный фильтр (это Chip) · счётчик числом (это нативный Badge)
 *  @breaks длинная фраза внутри — `whiteSpace: nowrap` выдавливает пилюлю за строку
 */
"use client";

import { ReactNode } from "react";
import { mix } from "@/lib/tokens/mix";

type Tone = "neutral" | "accent" | "glass";

const TONE: Record<Tone, { bg: string; fg: string }> = {
  neutral: { bg: "var(--surface-hover)", fg: "var(--dim)" },
  accent: { bg: mix("var(--accent)", 18), fg: "var(--accent)" },
  glass: { bg: "var(--cg-bg-overlay-heavy)", fg: "var(--cg-text-on-accent)" },
};

export function Tag({ children, tone = "neutral" }: { children: ReactNode; tone?: Tone }) {
  const t = TONE[tone];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "var(--cg-space-1)",
      padding: "2px 8px", borderRadius: "var(--cg-radius-full)", background: t.bg, color: t.fg,
      font: "600 var(--cg-font-xs)/1.2 var(--mono)", whiteSpace: "nowrap" }}>
      {children}
    </span>
  );
}
